import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=e17b1a30&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=ts"
export * from "./MemberDetails.vue?vue&type=script&lang=ts"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=e17b1a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17b1a30",
  null
  
)

export default component.exports